import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const withdrawalHistorySchema = z.object({
  /** Record ID */
  id: z.string(),
  /** Hash record of the withdrawal */
  txid: z.string().nullable().optional(),
  /** Block Number */
  block_number: z.string().nullable().optional(),
  /** Client order id（最大32文字、0-9, A-Z, a-z, _, -, . のみ使用可能） */
  withdraw_order_id: z.string().nullable().optional(),
  /** Operation time */
  timestamp: z.string(),
  /** Token amount */
  amount: decimalSchema,
  /** 手数料 */
  fee: decimalSchema,
  /** Currency name */
  currency: z.string(),
  /** Withdrawal address */
  address: z.string(),
  /** 出金失敗理由（status = CANCEL のときのみ値あり） */
  fail_reason: z.string().nullable().optional(),
  /** 出金完了またはキャンセル時刻（status により異なる） */
  timestamp2: z.string().nullable().optional(),
  /** 出金に関する備考 */
  memo: z.string().nullable().optional(),
  /** トランザクションの状態 */
  status: z.union([
    z.literal('DONE'),
    z.literal('CANCEL'),
    z.literal('REQUEST'),
    z.literal('MANUAL'),
    z.literal('BCODE'),
    z.literal('EXTPEND'),
    z.literal('FAIL'),
    z.literal('INVALID'),
    z.literal('VERIFY'),
    z.literal('PROCES'),
    z.literal('PEND'),
    z.literal('DMOVE'),
    z.literal('REVIEW'),
  ]),
  /** 出金に使用されたチェーン名 */
  chain: z.string(),
})

export const responseSchema = z.array(withdrawalHistorySchema)
